module.exports = __webpack_public_path__ + "img/app_web.d4fec18b.jpg";